export class Language {
    name: string;
    hearing: string;
    reading: string;
    interaction: string;
    speaking: string;
    writing: string;
}
